module.exports = __webpack_public_path__ + "assets/img/video-thumb-1.3b3d7da5.webp";